import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/lettre", label: "Lettre de candidature" },
  { to: "/profession-de-foi", label: "Profession de foi" },
  { to: "/programme", label: "3 priorités" },
  { to: "/actualites", label: "Actualités" },
  { to: "/videos", label: "Vidéos" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-[#FDFBF7] shadow-[0_2px_12px_rgb(0,0,0,0.06)] border-b border-black/5"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <span className="w-10 h-10 rounded-full bg-[#12495B] text-[#FDFBF7] flex items-center justify-center font-display text-xl">68</span>
          <span className="leading-tight">
            <span className="block font-display text-base sm:text-lg leading-tight text-[#12495B] font-semibold whitespace-nowrap">Pour une Alsace forte</span>
            <span className="block text-[10px] tracking-[0.25em] uppercase text-[#F5C518] font-bold">Sénatoriales · 27 sept. 2026</span>
          </span>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={`text-sm font-semibold transition-colors duration-300 hover:text-[#E0B400] ${
                pathname === l.to ? "text-[#E0B400]" : "text-[#12495B]"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="nav-contact-btn"
            className="px-6 py-2.5 rounded-full bg-[#F5C518] text-[#12495B] text-sm font-extrabold hover:bg-[#E0B400] transition-colors duration-300 shadow-[0_8px_30px_rgb(245,197,24,0.4)]"
          >
            Nous contacter
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden text-[#12495B]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#FDFBF7] border-t border-black/5 px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className="py-2 text-[#12495B] font-medium"
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/contact"
            onClick={() => setOpen(false)}
            className="mt-2 px-6 py-3 rounded-full bg-[#F5C518] text-[#12495B] text-center font-extrabold"
          >
            Nous contacter
          </Link>
        </div>
      )}
    </header>
  );
};
